export default __webpack_public_path__ + "static/media/logo-us-puma.d2165226.svg";